module.exports = __webpack_public_path__ + "img/kkmh@2X.c98a384c.png";